// ...existing code...
import React, { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Menu, MenuItem } from '@mui/material';
import { actions } from './Reports.redux';
import DeletePopover from 'components/DeletePopover';

const TemplatesCell = (params) => {
    const { field, row } = params;
    const id = row.template_id;
    const dispatch = useDispatch();
    const actionAnchor = useRef(null);
    const [actionsOpen, setActionsOpen] = useState(false);

    const beforeDeleteTemplate = useCallback(() => {
        dispatch(actions.setState({ loading: true }));
    }, [dispatch]);

    const afterDeleteTemplate = useCallback(() => {
        dispatch(actions.loadTemplates());
        setActionsOpen(false);
    }, [dispatch]);

    if (field !== 'actions') {
        return null;
    }

    return (
        <div onClick={(event) => event.stopPropagation()}>
            <Button
                variant="outlined"
                size="large"
                onClick={(event) => {
                    actionAnchor.current = event.currentTarget;
                    setActionsOpen(true);
                }}
            >
                ...
            </Button>
            <Menu open={actionsOpen} onClose={() => setActionsOpen(false)} anchorEl={actionAnchor.current}>
                <MenuItem>
                    <DeletePopover
                        objectType="TEMPLATE"
                        objectID={id}
                        afterDelete={afterDeleteTemplate}
                        beforeDelete={beforeDeleteTemplate}
                    >
                        <Button variant="text" size="large" color="error">
                            Delete Layout
                        </Button>
                    </DeletePopover>
                </MenuItem>
            </Menu>
        </div>
    );
};

export default TemplatesCell;
